export default __webpack_public_path__ + "static/media/podium.1b52f979.svg";